import React from "react";
import {connect} from "react-redux";
import {Alert, Button, Modal, Space, Spin, Tree} from "antd";
import {displayErrors} from "../../libs/utils";
import {getFTPDir} from "../../actions/domains";
import {Loading} from "../../libs/loading";

class SoftwareMigrationFTPPathModal extends React.Component {
    state = {
        loadingDir: true,
        dirTree: [],
        ftp_path: '/',
        connectionFailed: false,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && this.state.loadingDir && this.state.dirTree.length === 0) {
            this.loadDirectory(this.state.ftp_path);
        }
    }

    updateDirTree(list, key, newChildren) {
        if(list.length === 0) {
            return newChildren.map((item) => {
                return {
                    key: '/' + item,
                    title: item,
                    isLeaf: false
                }
            });
        } else {
            return list.map((item) => {
                if(item.key === key) {
                    let children = null;
                    if(newChildren.length > 0) {
                        children = newChildren.map((item) => {
                            return {
                                key: key + '/' + item,
                                title: item,
                                isLeaf: false
                            }
                        })
                    }

                    return { ...item, isLeaf: false, children };
                }

                if (item.children) {
                    return {
                        ...item,
                        children: this.updateDirTree(item.children, key, newChildren),
                    };
                }
                return item;
            })
        }
    }

    loadDirectory(path) {
        let data = {
            ftp_username: this.props.username,
            ftp_password: this.props.password,
            ftp_port: this.props.port,
            ftp_host: this.props.host,
            ftp_mode: this.props.mode,
            ftp_security: this.props.security,
            ftp_path: path,
        }

        this.props.getFTPDir(this.props.domain, data, (res) => {
            let dirTree = this.updateDirTree(this.state.dirTree, path, res.data);
            this.setState({ loadingDir: false, dirTree: dirTree })
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loadingDir: false, connectionFailed: true })
            }
        });
    }

    closeModal() {
        this.props.closeModal();

        this.setState({
            loadingDir: true,
            dirTree: [],
            ftp_path: '/',
            connectionFailed: false
        });
    }

    selectFolder() {
        this.props.updateFTPPath(this.state.ftp_path);
        this.closeModal();
    }

    loadData = ({ key }) => {
        return new Promise((resolve) => {
            this.setState({ loadingDir: true });
            this.loadDirectory(key);
            resolve();
        });
    }

    render() {
        let content = <Spin spinning={this.state.loadingDir}>
            <Tree
                treeData={this.state.dirTree}
                onSelect={(data) => this.setState({ ftp_path: data[0] }) }
                showLine
                loadData={this.loadData} />
        </Spin>;

        if(!this.state.connectionFailed && this.state.loadingDir && this.state.dirTree.length === 0) {
            content = <div className='text-center'><Loading /><p>Loading data from the FTP server...</p></div>;
        }

        if(this.state.connectionFailed) {
            content = <Alert type='error' showIcon message='Failed to connect to the FTP server.' />;
        }

        return <Modal
            open={this.props.showModal}
            title='Select FTP Path'
            footer={<Space>
                <Button disabled={this.state.loadingDir} onClick={() => this.closeModal()}>Close</Button>
                <Button type="primary" disabled={this.state.loadingDir} onClick={() => this.selectFolder()}>Select Folder</Button>
            </Space>}
            onCancel={() => this.closeModal()}>
            {content}
        </Modal>
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});


export default connect(mapStateToProps, { getFTPDir })(SoftwareMigrationFTPPathModal);